import PropTypes from 'prop-types';
import { groupShape } from '../../../AppPropTypes';

export const accountSettingsModalParamsItemShape = {
  useCase: PropTypes.string,
  workspace: PropTypes.shape(groupShape),
  workspaceId: PropTypes.string,
};
